import React from "react";
import { View, Text, StyleSheet, Dimensions, Platform } from "react-native";
import LhButton from "../../components/LhButton";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import FontFamily from "../../constants/fonts";
import { useTheme } from "../../theme";

// Props for ShiftHandOverWelcome component
interface ShiftHandOverWelcomeProps {
  openFilterOverlay: () => void;
}

const ShiftHandOverWelcome: React.FC<ShiftHandOverWelcomeProps> = ({
  openFilterOverlay,
}) => {
  const { colors } = useTheme();
  // Helper function to check if device is in mobile layout
  const isMobileView = () => {
    const windowWidth = Dimensions.get("window").width;
    return (
      Platform.OS === "ios" || Platform.OS === "android" || windowWidth < 768
    );
  };

  // Helper function to check if device is a very small mobile device
  const isVerySmallMobileView = () => {
    const windowWidth = Dimensions.get("window").width;
    return (
      (Platform.OS === "ios" || Platform.OS === "android") && windowWidth < 375
    );
  };

  // Determine whether to show button text based on screen size
  const showButtonText = !isVerySmallMobileView();

  return (
    <View style={styles.welcomeCard}>
      <View style={styles.welcomeContainer}>
        <View style={styles.welcomeLeftContent}>
          <Text style={[styles.welcomeText, { color: colors.text.primary }]}>Shift Handover Dashboard</Text>
        </View>
        <View
          style={
            isMobileView() ? styles.beginButtonRowMobile : styles.beginButtonRow
          }
        >
          <LhButton
            text={showButtonText ? "Begin" : ""}
            variant="primary"
            size="small"
            iconTrailing="arrow-forward"
            iconSize={20}
            onPress={openFilterOverlay}
            isLoading={false}
            disabled={false}
            style={showButtonText ? styles.beginButton : styles.iconOnlyButton}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  welcomeCard: {
    // backgroundColor: "white",
    // borderRadius: 8,
    // // marginBottom: 16,
    // borderLeftWidth: 4,
    // borderLeftColor: "#0066CC",
    // shadowColor: "#000",
    // shadowOffset: { width: 0, height: 1 },
    // shadowOpacity: 0.1,
    // shadowRadius: 3,
    // elevation: 2,
  },
  welcomeContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    // padding: 16,
    flexWrap: "nowrap",
  },
  welcomeLeftContent: {
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 1, // Allow this to shrink if needed
  },
  welcomeText: {
    fontFamily: FontFamily.bold,
    fontSize: 28,
    fontWeight: "700",
    color: "#2D2D2D",
    lineHeight:40,
    // marginLeft: 12,
    flexShrink: 1, // Allow text to shrink if needed
  },
  beginButtonRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
    alignItems: "center",
    width: "auto",
    marginTop: 0,
  },
  beginButtonRowMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "auto",
    marginTop: 0,
    gap: 10,
  },
  beginButton: {
    width:
      Dimensions.get("window").width < 400
        ? 90
        : Platform.OS === "web"
        ? "15%"
        : 120,
    minWidth: Platform.OS === "web" ? 120 : 60,
    fontSize: Dimensions.get("window").width < 400 ? 12 : 16,
  },
  iconOnlyButton: {
    width: 50,
    minWidth: 50,
    aspectRatio: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default ShiftHandOverWelcome;
